
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useRoutes } from 'react-router-dom';
import { useLocation } from 'react-router-dom'
import SplashView from '../pages/Splash/Splash';
import ServerErr from '../components/Errors/500';
import DesktopHeader from '../components/DesktopHeader/DesktopHeader';
import Menu from '../components/Menu/Menu';
import { useUserInfo } from '../pages/Profile/connect/User';
import routes from '../routes';
import { useOrders } from '../pages/DefaultPage/connect/Orders';
import DesktopSidebar from '../components/Menu/DesktopSidebar';

function DesktopLayout() {

    const showServerError = useOrders((state) => state.showServerError);
    let router = useRoutes(routes)
    const location = useLocation();

    console.log(location?.pathname?.length, "location?.pathname?.length location?.pathname?.length ");

    return (
        <>
            {
                showServerError ? (<ServerErr />) : (
                    <div className='block sm:hidden md:hidden lg:hidden  py-4 relative overflow-y-hidden'>
                        <DesktopHeader />
                        {
                            location.pathname === "/" ||
                                location?.pathname?.length == "2" ||
                                location?.pathname?.length == "3" ||
                                location?.pathname?.length == "4" ||
                                location.pathname.slice(0, 18) == "/buildingMaterials" ||
                                location.pathname.slice(0, 7) == "/metals" ||
                                location.pathname.slice(0, 15) == "/services-labor" ||
                                location.pathname.slice(0, 10) == "/equipment" ||
                                location.pathname.slice(0, 14) == "/machine-tools" ||
                                location.pathname.slice(0, 21) == "/architect-contractor" ||
                                location.pathname.slice(0, 20) == "/CommissionCalculate" ||
                                location.pathname === "/RegisterAD" ||
                                location.pathname === "/AdsOnMap" ||
                                location.pathname === "/CategoryView" ||
                                location.pathname === "/AllADS" ||
                                location.pathname === "/LoginStepOne" ||
                                location.pathname === "/LoginLocation" ||
                                location.pathname === "/LoginSecondStep" ||
                                location.pathname === "/LoginThirdStep" ||
                                location.pathname.slice(0, 9) === "/property" ||
                                location.pathname.slice(0, 16) === "/AdvertiseDetail" ||
                                location.pathname.slice(0, 9) === "/ChatPage" ||
                                location.pathname.slice(0, 11) === "/User" ||
                                // location.pathname === "/Messages" ||
                                location.pathname === "/SplashView" ||
                                location.pathname === "/CurrencesPage" ||
                                location.pathname === "/SelectAds" ||
                                location.pathname.slice(0, 5) === "/edit" ||
                                location.pathname.slice(0, 5) === "/Blog" ||
                                location.pathname.slice(0, 6) === "/Blogs" 
                                ? (

                                    <div className='grid grid-cols-1 gap-2 mt-[5rem] lg:mt-0 '>
                                        {router}
                                    </div>
                                ) : (
                                    <div className='grid grid-cols-6 gap-2 '>

                                        {localStorage.getItem("veeuToken") ? <DesktopSidebar /> : <></>}
                                       
                                        <div className='grid col-span-5  2xl:col-span-5 mt-[5rem] mr-10'>
                                            {router}
                                        </div>
                                    </div>
                                )
                        }
                    </div>
                )
            }
        </>
    )
}

export default DesktopLayout